import { getPublicConfig } from "@/shared/config/config"
import type { HttpClient } from "@/shared/types/HttpClient"

const { cmApiBaseUrl } = getPublicConfig()

export const createPlanCustomerApi = (client: HttpClient) => ({
  updatePlanCustomerParent: async (planCustomerId: string, customerId: string, oldCustomerId: string): Promise<void> =>
    client.patch<void>(`${cmApiBaseUrl}/v1/plan_customers/${planCustomerId}`, {
      customerId,
      oldCustomerId
    })
})
